<template>
  <div :class="col">
    <div class="alert" :class="[type]" role="alert" :style="{marginBottom: marginBottom}">
      <b v-if="header" style="margin-right: 0.5em;">
        <slot name="header">{{header}}</slot>
      </b>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    col: {
      type: String,
      default: 'col-lg-12'
    },
    header: {
      type: String,
      default: 'Uwaga!'
    },
    marginBottom: {
      type: String,
      // default: '20px'
      default: '0px'
    },
    alertType: {
      type: String,
      default: 'warning'
    }
  },
  data() {
    return {};
  },
  computed: {
    type() {
      return this.alertType.startsWith('alert-') ? this.alertType : 'alert-' + this.alertType;
    }
  }
};
</script>